import {newStackSx} from '@growcloud-io/dc/util/StackUtils';

export const newColumnStack = (
  proto={margin:1,padding:2},
  horizontal='left',
  vertical='center') => {
  return newStackSx(horizontal, vertical, proto)
}

export const newRowStack = (
  proto={margin:1,padding:1},
  horizontal='left',
  vertical='center') => {
  return newStackSx(horizontal, vertical, proto)
}